// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('@kreamun:token'));

  useEffect(() => {
	  const checkToken = async () => {
		if (token) {
		  api.defaults.headers.Authorization = `Bearer ${token}`;
		  try {
			const response = await api.get('/auth/verify');
			setUser(response.data.user);
		  } catch (error) {
			console.error('Token inválido:', error);
			logout();
		  } finally {
			setLoading(false);
		  }
		} else {
		  setLoading(false);
		}
	  };

	  checkToken();
	}, [token]); // Ahora la función está definida dentro del useEffect
	
	
  const verifyToken = async () => {
    try {
      const response = await api.get('/auth/verify');
      setUser(response.data.user);
    } catch (error) {
      console.error('Token inválido:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      const { token, user } = response.data;
      
      localStorage.setItem('@kreamun:token', token);
      api.defaults.headers.Authorization = `Bearer ${token}`;
      setToken(token);
      setUser(user);
      
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Error al iniciar sesión' 
      };
    }
  };

  const register = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    
    // IMPORTANTE: NO guardamos token porque el usuario debe verificar email
    // Solo mostramos mensaje de éxito
    
    return { 
      success: true, 
      message: response.data.message,
      needsVerification: true 
    };
  } catch (error) {
    return { 
      success: false, 
      error: error.response?.data?.error || 'Error al registrar' 
    };
  }
};
  const logout = () => {
    localStorage.removeItem('@kreamun:token');
    delete api.defaults.headers.Authorization;
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      register,
      logout,
      isAuthenticated: !!user
    }}>
      {children}
    </AuthContext.Provider>
  );
};